import { FC } from 'react'
import AddProductReqTableRow from './AddProductReqTableRow'
import { IProductReqModel } from '../../products/cors/_models'
import { useIntl } from 'react-intl'
import { useLocation } from 'react-router-dom';

interface IProps {
    data: IProductReqModel[]
    onEdit: (product: IProductReqModel) => void
    canEditRejected: boolean
}
const AddProductReqTable:FC<IProps> = ({data, onEdit, canEditRejected}) => {
  const location = useLocation();
  const urlParams = new URLSearchParams(location.search);
  const statusFilter = urlParams.get('status_filter');

  const {formatMessage} = useIntl()
  return (
    <>
        {/* begin::Table container */}
          {/* begin::Table */}
          <table className='table align-middle gs-0 gy-5'>
            {/* begin::Table head */}
            <thead>
              <tr>
                <th className='fw-bold p-0 px-3 text-uppercase'>{formatMessage({id: 'image'})}</th>
                <th className='fw-bold p-0 px-3 text-uppercase'>{formatMessage({id: 'prod_name'})}</th>
                <th className='fw-bold p-0 px-3 text-uppercase'>{formatMessage({id: 'barcode'})}</th>
                <th className='fw-bold p-0 px-3 text-uppercase'>{formatMessage({id: 'model_num'})}</th>
                <th className='fw-bold p-0 px-3 text-uppercase'>{formatMessage({id: 'qty'})}</th>
                <th className='fw-bold p-0 px-3 text-uppercase text-nowrap'>{formatMessage({id: 'sale_price'})}</th>
                <th className='fw-bold p-0 px-3 text-uppercase text-nowrap'>{formatMessage({id: 'brand'})}</th>
                <th className='fw-bold p-0 px-3 text-uppercase text-nowrap'>{formatMessage({id: 'date_added'})}</th>
                <th className='fw-bold p-0 px-3 text-uppercase text-nowrap'>{formatMessage({id: 'status'})}</th>
                {statusFilter === 'rejected' && (
                    <>
                      <th className='fw-bold p-0 px-3 text-uppercase text-nowrap'>{formatMessage({id: 'rejection_reason'})}</th>
                    </>
                )}
                <th className='fw-bold p-0 px-3 text-uppercase text-nowrap'>{formatMessage({id: 'actions'})}</th>
              </tr>
            </thead>
            {/* end::Table head */}
            {/* begin::Table body */}
            <tbody>
              {data && (
                data.map((item,index)=>(
                  <AddProductReqTableRow key={index} item={item} onEdit={onEdit} canEditRejected={canEditRejected} />
                ))
              )}
            </tbody>
            {/* end::Table body */}
          </table>
          {/* end::Table */}
        {/* end::Table container */}
    </>
  )
}

export default AddProductReqTable